import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'domestic_migrant_workers'

export const dataPointDefinition = {
  retracedId: 'domestic_migrant_workers',
  name: 'Domestic migrant workers',
  description:
    'The intent of this option selection is to understand if the facility has written policies and/or procedures in place on the topic of "Domestic migrant workers".',
  meta: {
    slcpMeta: {
      key: 'ms-pla-7x',
      number: 'MS-PLA-4-16',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'ms-pla-6',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],ms-pla-66x',
      machineShowHide: '[2],ms-pla-66x',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ms-pla-7x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 33990,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
